// ⚠️  Fichier généré par packages/tokens/build.mjs — ne pas éditer à la main.

export const tokens = {
  "color": {
    "primary": {
      "50": "oklch(97% 0.015 265)",
      "100": "oklch(95% 0.03 265)",
      "200": "oklch(90% 0.06 265)",
      "300": "oklch(83% 0.1 265)",
      "400": "oklch(72% 0.16 265)",
      "500": "oklch(58% 0.19 265)",
      "600": "oklch(51% 0.19 265)",
      "700": "oklch(44% 0.17 265)",
      "800": "oklch(37% 0.13 265)",
      "900": "oklch(30% 0.06 265)",
      "950": "oklch(24% 0.05 265)"
    },
    "secondary": {
      "50": "oklch(97% 0.015 200)",
      "100": "oklch(94% 0.03 200)",
      "200": "oklch(89% 0.06 200)",
      "300": "oklch(81% 0.09 200)",
      "400": "oklch(72% 0.11 200)",
      "500": "oklch(62% 0.11 200)",
      "600": "oklch(53% 0.1 200)",
      "700": "oklch(45% 0.085 200)",
      "800": "oklch(37% 0.07 200)",
      "900": "oklch(30% 0.05 200)",
      "950": "oklch(23% 0.04 200)"
    },
    "neutral": {
      "0": "oklch(100% 0 0)",
      "50": "oklch(99% 0.003 250)",
      "100": "oklch(97% 0.004 250)",
      "200": "oklch(94% 0.006 260)",
      "300": "oklch(90% 0.006 250)",
      "400": "oklch(74% 0.012 258)",
      "500": "oklch(60% 0.018 260)",
      "600": "oklch(52% 0.02 260)",
      "700": "oklch(31% 0.02 265)",
      "800": "oklch(25% 0.02 265)",
      "900": "oklch(22% 0.02 260)",
      "950": "oklch(17% 0.015 265)",
      "1000": "oklch(0% 0 0)"
    },
    "green": {
      "50": "oklch(96% 0.025 155)",
      "100": "oklch(92% 0.06 155)",
      "500": "oklch(62% 0.14 155)",
      "600": "oklch(54% 0.13 155)",
      "700": "oklch(45% 0.11 155)",
      "900": "oklch(28% 0.06 155)"
    },
    "amber": {
      "50": "oklch(97% 0.03 85)",
      "100": "oklch(93% 0.07 85)",
      "500": "oklch(75% 0.15 70)",
      "600": "oklch(66% 0.15 65)",
      "700": "oklch(54% 0.13 60)",
      "900": "oklch(31% 0.07 65)"
    },
    "red": {
      "50": "oklch(96% 0.02 25)",
      "100": "oklch(92% 0.05 25)",
      "300": "oklch(78% 0.13 25)",
      "400": "oklch(69% 0.17 25)",
      "500": "oklch(60% 0.19 25)",
      "600": "oklch(53% 0.19 25)",
      "700": "oklch(45% 0.16 25)",
      "900": "oklch(28% 0.08 25)"
    },
    "blue": {
      "50": "oklch(96% 0.02 250)",
      "100": "oklch(92% 0.05 250)",
      "500": "oklch(60% 0.16 250)",
      "600": "oklch(53% 0.16 250)",
      "700": "oklch(45% 0.14 250)",
      "900": "oklch(28% 0.07 250)"
    },
    "surface": "oklch(99% 0.003 250)",
    "surface-raised": "oklch(100% 0 0)",
    "surface-sunken": "oklch(97% 0.004 250)",
    "surface-overlay": "oklch(22% 0.02 260 / 0.4)",
    "fg": "oklch(22% 0.02 260)",
    "fg-muted": "oklch(52% 0.02 260)",
    "fg-subtle": "oklch(60% 0.018 260)",
    "fg-on-accent": "oklch(100% 0 0)",
    "border": "oklch(90% 0.006 250)",
    "border-strong": "oklch(60% 0.018 260)",
    "accent": "oklch(51% 0.19 265)",
    "accent-hover": "oklch(44% 0.17 265)",
    "accent-subtle": "oklch(95% 0.03 265)",
    "accent-fg": "oklch(44% 0.17 265)",
    "ring": "oklch(58% 0.19 265)",
    "success": "oklch(54% 0.13 155)",
    "success-subtle": "oklch(96% 0.025 155)",
    "success-fg": "oklch(45% 0.11 155)",
    "warning": "oklch(66% 0.15 65)",
    "warning-subtle": "oklch(97% 0.03 85)",
    "warning-fg": "oklch(54% 0.13 60)",
    "danger": "oklch(53% 0.19 25)",
    "danger-hover": "oklch(45% 0.16 25)",
    "danger-subtle": "oklch(96% 0.02 25)",
    "danger-fg": "oklch(45% 0.16 25)",
    "info": "oklch(53% 0.16 250)",
    "info-subtle": "oklch(96% 0.02 250)",
    "info-fg": "oklch(45% 0.14 250)",
    "syntax": {
      "keyword": "#7c3aed",
      "string": "#059669",
      "function": "#2563eb",
      "type": "#0891b2",
      "number": "#d97706",
      "tag": "#e11d48",
      "attribute": "#0284c7",
      "comment": "#94a3b8",
      "punctuation": "#64748b"
    }
  },
  "motion": {
    "duration": {
      "instant": "70ms",
      "fast": "120ms",
      "normal": "200ms",
      "slow": "320ms",
      "slower": "480ms"
    },
    "ease": {
      "standard": "cubic-bezier(0.2, 0, 0, 1)",
      "entrance": "cubic-bezier(0.05, 0.7, 0.1, 1)",
      "exit": "cubic-bezier(0.3, 0, 0.8, 0.15)",
      "spring": "cubic-bezier(0.34, 1.4, 0.64, 1)"
    }
  },
  "shadow": {
    "xs": "0 1px 2px 0 oklch(0% 0 0 / 0.04)",
    "raised-inset": "inset 0 1px 0 0 oklch(100% 0 0 / 0.16)",
    "control-inset": "inset 0 1px 1px 0 oklch(0% 0 0 / 0.04)",
    "sm": "0 1px 3px 0 oklch(0% 0 0 / 0.06), 0 1px 2px -1px oklch(0% 0 0 / 0.04)",
    "md": "0 4px 10px -2px oklch(0% 0 0 / 0.07), 0 2px 4px -2px oklch(0% 0 0 / 0.04)",
    "lg": "0 12px 24px -8px oklch(0% 0 0 / 0.12), 0 4px 8px -4px oklch(0% 0 0 / 0.05)",
    "overlay": "0 24px 48px -12px oklch(0% 0 0 / 0.2)",
    "glass-inset": "inset 0 1px 0 0 oklch(100% 0 0 / 0.25)"
  },
  "spacing": {
    "0": "0rem",
    "1": "0.25rem",
    "2": "0.5rem",
    "3": "0.75rem",
    "4": "1rem",
    "5": "1.25rem",
    "6": "1.5rem",
    "8": "2rem",
    "10": "2.5rem",
    "12": "3rem",
    "16": "4rem",
    "20": "5rem",
    "24": "6rem",
    "32": "8rem",
    "base": "0.25rem"
  },
  "radius": {
    "none": "0rem",
    "sm": "0.375rem",
    "md": "0.5rem",
    "lg": "0.75rem",
    "xl": "1rem",
    "2xl": "1.25rem",
    "full": "9999px"
  },
  "font": {
    "family": {
      "sans": "Inter, ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
      "display": "'Inter Display', Inter, ui-sans-serif, system-ui, sans-serif",
      "mono": "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace"
    },
    "size": {
      "xs": "0.75rem",
      "sm": "0.875rem",
      "base": "1rem",
      "lg": "1.125rem",
      "xl": "1.25rem",
      "2xl": "1.5rem",
      "3xl": "1.875rem",
      "4xl": "2.25rem",
      "5xl": "3rem",
      "6xl": "3.75rem"
    },
    "weight": {
      "normal": "400",
      "medium": "500",
      "semibold": "600",
      "bold": "700"
    },
    "tracking": {
      "tight": "-0.025em",
      "normal": "0em",
      "wide": "0.025em"
    }
  }
};

export const tokenList = [
  {
    "path": [
      "color",
      "primary",
      "50"
    ],
    "name": "color-primary-50",
    "cssVar": "--nx-color-primary-50",
    "type": "color",
    "value": "oklch(97% 0.015 265)",
    "hex": "#f0f5ff"
  },
  {
    "path": [
      "color",
      "primary",
      "100"
    ],
    "name": "color-primary-100",
    "cssVar": "--nx-color-primary-100",
    "type": "color",
    "value": "oklch(95% 0.03 265)",
    "hex": "#e5efff"
  },
  {
    "path": [
      "color",
      "primary",
      "200"
    ],
    "name": "color-primary-200",
    "cssVar": "--nx-color-primary-200",
    "type": "color",
    "value": "oklch(90% 0.06 265)",
    "hex": "#cbdeff"
  },
  {
    "path": [
      "color",
      "primary",
      "300"
    ],
    "name": "color-primary-300",
    "cssVar": "--nx-color-primary-300",
    "type": "color",
    "value": "oklch(83% 0.1 265)",
    "hex": "#a8c7ff"
  },
  {
    "path": [
      "color",
      "primary",
      "400"
    ],
    "name": "color-primary-400",
    "cssVar": "--nx-color-primary-400",
    "type": "color",
    "value": "oklch(72% 0.16 265)",
    "hex": "#73a0ff"
  },
  {
    "path": [
      "color",
      "primary",
      "500"
    ],
    "name": "color-primary-500",
    "cssVar": "--nx-color-primary-500",
    "type": "color",
    "value": "oklch(58% 0.19 265)",
    "hex": "#4170e9"
  },
  {
    "path": [
      "color",
      "primary",
      "600"
    ],
    "name": "color-primary-600",
    "cssVar": "--nx-color-primary-600",
    "type": "color",
    "value": "oklch(51% 0.19 265)",
    "hex": "#2e5ad1"
  },
  {
    "path": [
      "color",
      "primary",
      "700"
    ],
    "name": "color-primary-700",
    "cssVar": "--nx-color-primary-700",
    "type": "color",
    "value": "oklch(44% 0.17 265)",
    "hex": "#2347ae"
  },
  {
    "path": [
      "color",
      "primary",
      "800"
    ],
    "name": "color-primary-800",
    "cssVar": "--nx-color-primary-800",
    "type": "color",
    "value": "oklch(37% 0.13 265)",
    "hex": "#1d3983"
  },
  {
    "path": [
      "color",
      "primary",
      "900"
    ],
    "name": "color-primary-900",
    "cssVar": "--nx-color-primary-900",
    "type": "color",
    "value": "oklch(30% 0.06 265)",
    "hex": "#1f2d4c"
  },
  {
    "path": [
      "color",
      "primary",
      "950"
    ],
    "name": "color-primary-950",
    "cssVar": "--nx-color-primary-950",
    "type": "color",
    "value": "oklch(24% 0.05 265)",
    "hex": "#131e37"
  },
  {
    "path": [
      "color",
      "secondary",
      "50"
    ],
    "name": "color-secondary-50",
    "cssVar": "--nx-color-secondary-50",
    "type": "color",
    "value": "oklch(97% 0.015 200)",
    "hex": "#eaf8f9"
  },
  {
    "path": [
      "color",
      "secondary",
      "100"
    ],
    "name": "color-secondary-100",
    "cssVar": "--nx-color-secondary-100",
    "type": "color",
    "value": "oklch(94% 0.03 200)",
    "hex": "#d5f2f3"
  },
  {
    "path": [
      "color",
      "secondary",
      "200"
    ],
    "name": "color-secondary-200",
    "cssVar": "--nx-color-secondary-200",
    "type": "color",
    "value": "oklch(89% 0.06 200)",
    "hex": "#ace7ea"
  },
  {
    "path": [
      "color",
      "secondary",
      "300"
    ],
    "name": "color-secondary-300",
    "cssVar": "--nx-color-secondary-300",
    "type": "color",
    "value": "oklch(81% 0.09 200)",
    "hex": "#74d3d8"
  },
  {
    "path": [
      "color",
      "secondary",
      "400"
    ],
    "name": "color-secondary-400",
    "cssVar": "--nx-color-secondary-400",
    "type": "color",
    "value": "oklch(72% 0.11 200)",
    "hex": "#35b9c0"
  },
  {
    "path": [
      "color",
      "secondary",
      "500"
    ],
    "name": "color-secondary-500",
    "cssVar": "--nx-color-secondary-500",
    "type": "color",
    "value": "oklch(62% 0.11 200)",
    "hex": "#0099a0"
  },
  {
    "path": [
      "color",
      "secondary",
      "600"
    ],
    "name": "color-secondary-600",
    "cssVar": "--nx-color-secondary-600",
    "type": "color",
    "value": "oklch(53% 0.1 200)",
    "hex": "#007c83"
  },
  {
    "path": [
      "color",
      "secondary",
      "700"
    ],
    "name": "color-secondary-700",
    "cssVar": "--nx-color-secondary-700",
    "type": "color",
    "value": "oklch(45% 0.085 200)",
    "hex": "#006368"
  },
  {
    "path": [
      "color",
      "secondary",
      "800"
    ],
    "name": "color-secondary-800",
    "cssVar": "--nx-color-secondary-800",
    "type": "color",
    "value": "oklch(37% 0.07 200)",
    "hex": "#004a4e"
  },
  {
    "path": [
      "color",
      "secondary",
      "900"
    ],
    "name": "color-secondary-900",
    "cssVar": "--nx-color-secondary-900",
    "type": "color",
    "value": "oklch(30% 0.05 200)",
    "hex": "#023538"
  },
  {
    "path": [
      "color",
      "secondary",
      "950"
    ],
    "name": "color-secondary-950",
    "cssVar": "--nx-color-secondary-950",
    "type": "color",
    "value": "oklch(23% 0.04 200)",
    "hex": "#002224"
  },
  {
    "path": [
      "color",
      "neutral",
      "0"
    ],
    "name": "color-neutral-0",
    "cssVar": "--nx-color-neutral-0",
    "type": "color",
    "value": "oklch(100% 0 0)",
    "hex": "#ffffff"
  },
  {
    "path": [
      "color",
      "neutral",
      "50"
    ],
    "name": "color-neutral-50",
    "cssVar": "--nx-color-neutral-50",
    "type": "color",
    "value": "oklch(99% 0.003 250)",
    "hex": "#fafcfe"
  },
  {
    "path": [
      "color",
      "neutral",
      "100"
    ],
    "name": "color-neutral-100",
    "cssVar": "--nx-color-neutral-100",
    "type": "color",
    "value": "oklch(97% 0.004 250)",
    "hex": "#f3f5f8"
  },
  {
    "path": [
      "color",
      "neutral",
      "200"
    ],
    "name": "color-neutral-200",
    "cssVar": "--nx-color-neutral-200",
    "type": "color",
    "value": "oklch(94% 0.006 260)",
    "hex": "#e9ebef"
  },
  {
    "path": [
      "color",
      "neutral",
      "300"
    ],
    "name": "color-neutral-300",
    "cssVar": "--nx-color-neutral-300",
    "type": "color",
    "value": "oklch(90% 0.006 250)",
    "hex": "#dbdee2"
  },
  {
    "path": [
      "color",
      "neutral",
      "400"
    ],
    "name": "color-neutral-400",
    "cssVar": "--nx-color-neutral-400",
    "type": "color",
    "value": "oklch(74% 0.012 258)",
    "hex": "#a6abb3"
  },
  {
    "path": [
      "color",
      "neutral",
      "500"
    ],
    "name": "color-neutral-500",
    "cssVar": "--nx-color-neutral-500",
    "type": "color",
    "value": "oklch(60% 0.018 260)",
    "hex": "#7a818b"
  },
  {
    "path": [
      "color",
      "neutral",
      "600"
    ],
    "name": "color-neutral-600",
    "cssVar": "--nx-color-neutral-600",
    "type": "color",
    "value": "oklch(52% 0.02 260)",
    "hex": "#626975"
  },
  {
    "path": [
      "color",
      "neutral",
      "700"
    ],
    "name": "color-neutral-700",
    "cssVar": "--nx-color-neutral-700",
    "type": "color",
    "value": "oklch(31% 0.02 265)",
    "hex": "#2b303b"
  },
  {
    "path": [
      "color",
      "neutral",
      "800"
    ],
    "name": "color-neutral-800",
    "cssVar": "--nx-color-neutral-800",
    "type": "color",
    "value": "oklch(25% 0.02 265)",
    "hex": "#1d222b"
  },
  {
    "path": [
      "color",
      "neutral",
      "900"
    ],
    "name": "color-neutral-900",
    "cssVar": "--nx-color-neutral-900",
    "type": "color",
    "value": "oklch(22% 0.02 260)",
    "hex": "#151b24"
  },
  {
    "path": [
      "color",
      "neutral",
      "950"
    ],
    "name": "color-neutral-950",
    "cssVar": "--nx-color-neutral-950",
    "type": "color",
    "value": "oklch(17% 0.015 265)",
    "hex": "#0c0f16"
  },
  {
    "path": [
      "color",
      "neutral",
      "1000"
    ],
    "name": "color-neutral-1000",
    "cssVar": "--nx-color-neutral-1000",
    "type": "color",
    "value": "oklch(0% 0 0)",
    "hex": "#000000"
  },
  {
    "path": [
      "color",
      "green",
      "50"
    ],
    "name": "color-green-50",
    "cssVar": "--nx-color-green-50",
    "type": "color",
    "value": "oklch(96% 0.025 155)",
    "hex": "#e5f7eb"
  },
  {
    "path": [
      "color",
      "green",
      "100"
    ],
    "name": "color-green-100",
    "cssVar": "--nx-color-green-100",
    "type": "color",
    "value": "oklch(92% 0.06 155)",
    "hex": "#c6f1d3"
  },
  {
    "path": [
      "color",
      "green",
      "500"
    ],
    "name": "color-green-500",
    "cssVar": "--nx-color-green-500",
    "type": "color",
    "value": "oklch(62% 0.14 155)",
    "hex": "#269e5f"
  },
  {
    "path": [
      "color",
      "green",
      "600"
    ],
    "name": "color-green-600",
    "cssVar": "--nx-color-green-600",
    "type": "color",
    "value": "oklch(54% 0.13 155)",
    "hex": "#0d844c"
  },
  {
    "path": [
      "color",
      "green",
      "700"
    ],
    "name": "color-green-700",
    "cssVar": "--nx-color-green-700",
    "type": "color",
    "value": "oklch(45% 0.11 155)",
    "hex": "#036639"
  },
  {
    "path": [
      "color",
      "green",
      "900"
    ],
    "name": "color-green-900",
    "cssVar": "--nx-color-green-900",
    "type": "color",
    "value": "oklch(28% 0.06 155)",
    "hex": "#09311b"
  },
  {
    "path": [
      "color",
      "amber",
      "50"
    ],
    "name": "color-amber-50",
    "cssVar": "--nx-color-amber-50",
    "type": "color",
    "value": "oklch(97% 0.03 85)",
    "hex": "#fef4df"
  },
  {
    "path": [
      "color",
      "amber",
      "100"
    ],
    "name": "color-amber-100",
    "cssVar": "--nx-color-amber-100",
    "type": "color",
    "value": "oklch(93% 0.07 85)",
    "hex": "#fee5b3"
  },
  {
    "path": [
      "color",
      "amber",
      "500"
    ],
    "name": "color-amber-500",
    "cssVar": "--nx-color-amber-500",
    "type": "color",
    "value": "oklch(75% 0.15 70)",
    "hex": "#e99b2a"
  },
  {
    "path": [
      "color",
      "amber",
      "600"
    ],
    "name": "color-amber-600",
    "cssVar": "--nx-color-amber-600",
    "type": "color",
    "value": "oklch(66% 0.15 65)",
    "hex": "#cf7b00"
  },
  {
    "path": [
      "color",
      "amber",
      "700"
    ],
    "name": "color-amber-700",
    "cssVar": "--nx-color-amber-700",
    "type": "color",
    "value": "oklch(54% 0.13 60)",
    "hex": "#a45900"
  },
  {
    "path": [
      "color",
      "amber",
      "900"
    ],
    "name": "color-amber-900",
    "cssVar": "--nx-color-amber-900",
    "type": "color",
    "value": "oklch(31% 0.07 65)",
    "hex": "#482700"
  },
  {
    "path": [
      "color",
      "red",
      "50"
    ],
    "name": "color-red-50",
    "cssVar": "--nx-color-red-50",
    "type": "color",
    "value": "oklch(96% 0.02 25)",
    "hex": "#ffedeb"
  },
  {
    "path": [
      "color",
      "red",
      "100"
    ],
    "name": "color-red-100",
    "cssVar": "--nx-color-red-100",
    "type": "color",
    "value": "oklch(92% 0.05 25)",
    "hex": "#ffd8d4"
  },
  {
    "path": [
      "color",
      "red",
      "300"
    ],
    "name": "color-red-300",
    "cssVar": "--nx-color-red-300",
    "type": "color",
    "value": "oklch(78% 0.13 25)",
    "hex": "#ff958d"
  },
  {
    "path": [
      "color",
      "red",
      "400"
    ],
    "name": "color-red-400",
    "cssVar": "--nx-color-red-400",
    "type": "color",
    "value": "oklch(69% 0.17 25)",
    "hex": "#f26a64"
  },
  {
    "path": [
      "color",
      "red",
      "500"
    ],
    "name": "color-red-500",
    "cssVar": "--nx-color-red-500",
    "type": "color",
    "value": "oklch(60% 0.19 25)",
    "hex": "#db4241"
  },
  {
    "path": [
      "color",
      "red",
      "600"
    ],
    "name": "color-red-600",
    "cssVar": "--nx-color-red-600",
    "type": "color",
    "value": "oklch(53% 0.19 25)",
    "hex": "#c2272d"
  },
  {
    "path": [
      "color",
      "red",
      "700"
    ],
    "name": "color-red-700",
    "cssVar": "--nx-color-red-700",
    "type": "color",
    "value": "oklch(45% 0.16 25)",
    "hex": "#9b1e22"
  },
  {
    "path": [
      "color",
      "red",
      "900"
    ],
    "name": "color-red-900",
    "cssVar": "--nx-color-red-900",
    "type": "color",
    "value": "oklch(28% 0.08 25)",
    "hex": "#491513"
  },
  {
    "path": [
      "color",
      "blue",
      "50"
    ],
    "name": "color-blue-50",
    "cssVar": "--nx-color-blue-50",
    "type": "color",
    "value": "oklch(96% 0.02 250)",
    "hex": "#e8f3ff"
  },
  {
    "path": [
      "color",
      "blue",
      "100"
    ],
    "name": "color-blue-100",
    "cssVar": "--nx-color-blue-100",
    "type": "color",
    "value": "oklch(92% 0.05 250)",
    "hex": "#cce8ff"
  },
  {
    "path": [
      "color",
      "blue",
      "500"
    ],
    "name": "color-blue-500",
    "cssVar": "--nx-color-blue-500",
    "type": "color",
    "value": "oklch(60% 0.16 250)",
    "hex": "#1a83db"
  },
  {
    "path": [
      "color",
      "blue",
      "600"
    ],
    "name": "color-blue-600",
    "cssVar": "--nx-color-blue-600",
    "type": "color",
    "value": "oklch(53% 0.16 250)",
    "hex": "#006dc3"
  },
  {
    "path": [
      "color",
      "blue",
      "700"
    ],
    "name": "color-blue-700",
    "cssVar": "--nx-color-blue-700",
    "type": "color",
    "value": "oklch(45% 0.14 250)",
    "hex": "#00569f"
  },
  {
    "path": [
      "color",
      "blue",
      "900"
    ],
    "name": "color-blue-900",
    "cssVar": "--nx-color-blue-900",
    "type": "color",
    "value": "oklch(28% 0.07 250)",
    "hex": "#072a4a"
  },
  {
    "path": [
      "color",
      "surface"
    ],
    "name": "color-surface",
    "cssVar": "--nx-color-surface",
    "type": "color",
    "value": "oklch(99% 0.003 250)",
    "darkValue": "oklch(17% 0.015 265)",
    "hex": "#fafcfe",
    "darkHex": "#0c0f16",
    "description": "Fond de page."
  },
  {
    "path": [
      "color",
      "surface-raised"
    ],
    "name": "color-surface-raised",
    "cssVar": "--nx-color-surface-raised",
    "type": "color",
    "value": "oklch(100% 0 0)",
    "darkValue": "oklch(22% 0.02 260)",
    "hex": "#ffffff",
    "darkHex": "#151b24",
    "description": "Fond des éléments posés sur la page : cards, popovers, barres."
  },
  {
    "path": [
      "color",
      "surface-sunken"
    ],
    "name": "color-surface-sunken",
    "cssVar": "--nx-color-surface-sunken",
    "type": "color",
    "value": "oklch(97% 0.004 250)",
    "darkValue": "oklch(25% 0.02 265)",
    "hex": "#f3f5f8",
    "darkHex": "#1d222b",
    "description": "Fond en retrait : zones de code, en-têtes de tableau, états survolés."
  },
  {
    "path": [
      "color",
      "surface-overlay"
    ],
    "name": "color-surface-overlay",
    "cssVar": "--nx-color-surface-overlay",
    "type": "color",
    "value": "oklch(22% 0.02 260 / 0.4)",
    "darkValue": "oklch(0% 0 0 / 0.6)",
    "hex": "#151b2466",
    "darkHex": "#00000099",
    "description": "Voile derrière une modale."
  },
  {
    "path": [
      "color",
      "fg"
    ],
    "name": "color-fg",
    "cssVar": "--nx-color-fg",
    "type": "color",
    "value": "oklch(22% 0.02 260)",
    "darkValue": "oklch(94% 0.006 260)",
    "hex": "#151b24",
    "darkHex": "#e9ebef",
    "description": "Texte principal."
  },
  {
    "path": [
      "color",
      "fg-muted"
    ],
    "name": "color-fg-muted",
    "cssVar": "--nx-color-fg-muted",
    "type": "color",
    "value": "oklch(52% 0.02 260)",
    "darkValue": "oklch(74% 0.012 258)",
    "hex": "#626975",
    "darkHex": "#a6abb3",
    "description": "Texte secondaire, légendes, placeholders. Les deux thèmes ne visent PAS la même nuance : sur fond sombre il faut monter à la 400 pour rester au-dessus de 4,5:1. Une échelle inversée symétriquement échouerait."
  },
  {
    "path": [
      "color",
      "fg-subtle"
    ],
    "name": "color-fg-subtle",
    "cssVar": "--nx-color-fg-subtle",
    "type": "color",
    "value": "oklch(60% 0.018 260)",
    "darkValue": "oklch(52% 0.02 260)",
    "hex": "#7a818b",
    "darkHex": "#626975",
    "description": "Éléments DÉSACTIVÉS et décor typographique (chevrons, icônes d'ornement). Contraste ~2,9:1, volontairement sous le seuil AA : WCAG 1.4.3 exempte les composants inactifs, et les atténuer est précisément ce qui signale leur inactivité. Ne jamais l'utiliser pour du texte lisible — un placeholder relève de fg-muted."
  },
  {
    "path": [
      "color",
      "fg-on-accent"
    ],
    "name": "color-fg-on-accent",
    "cssVar": "--nx-color-fg-on-accent",
    "type": "color",
    "value": "oklch(100% 0 0)",
    "darkValue": "oklch(17% 0.015 265)",
    "hex": "#ffffff",
    "darkHex": "#0c0f16",
    "description": "Texte posé sur un aplat coloré (accent, danger…). En thème sombre l'aplat s'éclaircit (accent = primary.400) : le texte doit donc s'assombrir, sinon le contraste tombe à 2,6:1. C'est l'erreur la plus courante quand on se contente d'inverser les fonds."
  },
  {
    "path": [
      "color",
      "border"
    ],
    "name": "color-border",
    "cssVar": "--nx-color-border",
    "type": "color",
    "value": "oklch(90% 0.006 250)",
    "darkValue": "oklch(31% 0.02 265)",
    "hex": "#dbdee2",
    "darkHex": "#2b303b",
    "description": "Bordure par défaut : séparateurs, contours de cards."
  },
  {
    "path": [
      "color",
      "border-strong"
    ],
    "name": "color-border-strong",
    "cssVar": "--nx-color-border-strong",
    "type": "color",
    "value": "oklch(60% 0.018 260)",
    "darkValue": "oklch(52% 0.02 260)",
    "hex": "#7a818b",
    "darkHex": "#626975",
    "description": "Bordure d'un élément interactif : champ de formulaire, bouton outline. Nettement plus soutenue que `border` — WCAG 1.4.11 exige 3:1 pour le contour qui permet d'identifier un composant, alors qu'un simple séparateur décoratif n'est soumis à aucun seuil."
  },
  {
    "path": [
      "color",
      "accent"
    ],
    "name": "color-accent",
    "cssVar": "--nx-color-accent",
    "type": "color",
    "value": "oklch(51% 0.19 265)",
    "darkValue": "oklch(72% 0.16 265)",
    "hex": "#2e5ad1",
    "darkHex": "#73a0ff",
    "description": "Aplat de marque au repos. Pointe sur la 600 et non la 500 : en blanc sur la 500, le contraste tombe à 4,45:1, juste sous le seuil AA de 4,5:1. La 600 monte à 6,4:1 pour un écart visuel imperceptible — la primitive, elle, conserve la valeur exacte de la marque."
  },
  {
    "path": [
      "color",
      "accent-hover"
    ],
    "name": "color-accent-hover",
    "cssVar": "--nx-color-accent-hover",
    "type": "color",
    "value": "oklch(44% 0.17 265)",
    "darkValue": "oklch(83% 0.1 265)",
    "hex": "#2347ae",
    "darkHex": "#a8c7ff",
    "description": "Aplat de marque au survol."
  },
  {
    "path": [
      "color",
      "accent-subtle"
    ],
    "name": "color-accent-subtle",
    "cssVar": "--nx-color-accent-subtle",
    "type": "color",
    "value": "oklch(95% 0.03 265)",
    "darkValue": "oklch(30% 0.06 265)",
    "hex": "#e5efff",
    "darkHex": "#1f2d4c",
    "description": "Fond de marque très léger : chips, onglet actif, ligne sélectionnée."
  },
  {
    "path": [
      "color",
      "accent-fg"
    ],
    "name": "color-accent-fg",
    "cssVar": "--nx-color-accent-fg",
    "type": "color",
    "value": "oklch(44% 0.17 265)",
    "darkValue": "oklch(90% 0.06 265)",
    "hex": "#2347ae",
    "darkHex": "#cbdeff",
    "description": "Texte de marque posé sur accent-subtle ou sur la surface."
  },
  {
    "path": [
      "color",
      "ring"
    ],
    "name": "color-ring",
    "cssVar": "--nx-color-ring",
    "type": "color",
    "value": "oklch(58% 0.19 265)",
    "darkValue": "oklch(72% 0.16 265)",
    "hex": "#4170e9",
    "darkHex": "#73a0ff",
    "description": "Anneau de focus. Doit rester perceptible dans les deux thèmes — exigence WCAG 2.4.7."
  },
  {
    "path": [
      "color",
      "success"
    ],
    "name": "color-success",
    "cssVar": "--nx-color-success",
    "type": "color",
    "value": "oklch(54% 0.13 155)",
    "darkValue": "oklch(62% 0.14 155)",
    "hex": "#0d844c",
    "darkHex": "#269e5f"
  },
  {
    "path": [
      "color",
      "success-subtle"
    ],
    "name": "color-success-subtle",
    "cssVar": "--nx-color-success-subtle",
    "type": "color",
    "value": "oklch(96% 0.025 155)",
    "darkValue": "oklch(28% 0.06 155)",
    "hex": "#e5f7eb",
    "darkHex": "#09311b"
  },
  {
    "path": [
      "color",
      "success-fg"
    ],
    "name": "color-success-fg",
    "cssVar": "--nx-color-success-fg",
    "type": "color",
    "value": "oklch(45% 0.11 155)",
    "darkValue": "oklch(92% 0.06 155)",
    "hex": "#036639",
    "darkHex": "#c6f1d3"
  },
  {
    "path": [
      "color",
      "warning"
    ],
    "name": "color-warning",
    "cssVar": "--nx-color-warning",
    "type": "color",
    "value": "oklch(66% 0.15 65)",
    "darkValue": "oklch(75% 0.15 70)",
    "hex": "#cf7b00",
    "darkHex": "#e99b2a"
  },
  {
    "path": [
      "color",
      "warning-subtle"
    ],
    "name": "color-warning-subtle",
    "cssVar": "--nx-color-warning-subtle",
    "type": "color",
    "value": "oklch(97% 0.03 85)",
    "darkValue": "oklch(31% 0.07 65)",
    "hex": "#fef4df",
    "darkHex": "#482700"
  },
  {
    "path": [
      "color",
      "warning-fg"
    ],
    "name": "color-warning-fg",
    "cssVar": "--nx-color-warning-fg",
    "type": "color",
    "value": "oklch(54% 0.13 60)",
    "darkValue": "oklch(93% 0.07 85)",
    "hex": "#a45900",
    "darkHex": "#fee5b3"
  },
  {
    "path": [
      "color",
      "danger"
    ],
    "name": "color-danger",
    "cssVar": "--nx-color-danger",
    "type": "color",
    "value": "oklch(53% 0.19 25)",
    "darkValue": "oklch(69% 0.17 25)",
    "hex": "#c2272d",
    "darkHex": "#f26a64",
    "description": "Aplat destructif. Même logique que l'accent : la teinte s'inverse entre les thèmes pour rester lisible avec fg-on-accent."
  },
  {
    "path": [
      "color",
      "danger-hover"
    ],
    "name": "color-danger-hover",
    "cssVar": "--nx-color-danger-hover",
    "type": "color",
    "value": "oklch(45% 0.16 25)",
    "darkValue": "oklch(78% 0.13 25)",
    "hex": "#9b1e22",
    "darkHex": "#ff958d"
  },
  {
    "path": [
      "color",
      "danger-subtle"
    ],
    "name": "color-danger-subtle",
    "cssVar": "--nx-color-danger-subtle",
    "type": "color",
    "value": "oklch(96% 0.02 25)",
    "darkValue": "oklch(28% 0.08 25)",
    "hex": "#ffedeb",
    "darkHex": "#491513"
  },
  {
    "path": [
      "color",
      "danger-fg"
    ],
    "name": "color-danger-fg",
    "cssVar": "--nx-color-danger-fg",
    "type": "color",
    "value": "oklch(45% 0.16 25)",
    "darkValue": "oklch(92% 0.05 25)",
    "hex": "#9b1e22",
    "darkHex": "#ffd8d4"
  },
  {
    "path": [
      "color",
      "info"
    ],
    "name": "color-info",
    "cssVar": "--nx-color-info",
    "type": "color",
    "value": "oklch(53% 0.16 250)",
    "darkValue": "oklch(60% 0.16 250)",
    "hex": "#006dc3",
    "darkHex": "#1a83db"
  },
  {
    "path": [
      "color",
      "info-subtle"
    ],
    "name": "color-info-subtle",
    "cssVar": "--nx-color-info-subtle",
    "type": "color",
    "value": "oklch(96% 0.02 250)",
    "darkValue": "oklch(28% 0.07 250)",
    "hex": "#e8f3ff",
    "darkHex": "#072a4a"
  },
  {
    "path": [
      "color",
      "info-fg"
    ],
    "name": "color-info-fg",
    "cssVar": "--nx-color-info-fg",
    "type": "color",
    "value": "oklch(45% 0.14 250)",
    "darkValue": "oklch(92% 0.05 250)",
    "hex": "#00569f",
    "darkHex": "#cce8ff"
  },
  {
    "path": [
      "color",
      "syntax",
      "keyword"
    ],
    "name": "color-syntax-keyword",
    "cssVar": "--nx-color-syntax-keyword",
    "type": "color",
    "value": "#7c3aed",
    "darkValue": "#a855f7",
    "hex": "#7c3aed",
    "darkHex": "#a855f7",
    "description": "Mots réservés du langage : const, function, return, if."
  },
  {
    "path": [
      "color",
      "syntax",
      "string"
    ],
    "name": "color-syntax-string",
    "cssVar": "--nx-color-syntax-string",
    "type": "color",
    "value": "#059669",
    "darkValue": "#10b981",
    "hex": "#059669",
    "darkHex": "#10b981",
    "description": "Littéraux de chaîne et de caractère."
  },
  {
    "path": [
      "color",
      "syntax",
      "function"
    ],
    "name": "color-syntax-function",
    "cssVar": "--nx-color-syntax-function",
    "type": "color",
    "value": "#2563eb",
    "darkValue": "#60a5fa",
    "hex": "#2563eb",
    "darkHex": "#60a5fa",
    "description": "Noms de fonctions et de méthodes, à l'appel comme à la déclaration."
  },
  {
    "path": [
      "color",
      "syntax",
      "type"
    ],
    "name": "color-syntax-type",
    "cssVar": "--nx-color-syntax-type",
    "type": "color",
    "value": "#0891b2",
    "darkValue": "#06b6d4",
    "hex": "#0891b2",
    "darkHex": "#06b6d4",
    "description": "Noms de classes, de types et d'interfaces."
  },
  {
    "path": [
      "color",
      "syntax",
      "number"
    ],
    "name": "color-syntax-number",
    "cssVar": "--nx-color-syntax-number",
    "type": "color",
    "value": "#d97706",
    "darkValue": "#f59e0b",
    "hex": "#d97706",
    "darkHex": "#f59e0b",
    "description": "Nombres, booléens et constantes."
  },
  {
    "path": [
      "color",
      "syntax",
      "tag"
    ],
    "name": "color-syntax-tag",
    "cssVar": "--nx-color-syntax-tag",
    "type": "color",
    "value": "#e11d48",
    "darkValue": "#f43f5e",
    "hex": "#e11d48",
    "darkHex": "#f43f5e",
    "description": "Balises de balisage et éléments JSX."
  },
  {
    "path": [
      "color",
      "syntax",
      "attribute"
    ],
    "name": "color-syntax-attribute",
    "cssVar": "--nx-color-syntax-attribute",
    "type": "color",
    "value": "#0284c7",
    "darkValue": "#38bdf8",
    "hex": "#0284c7",
    "darkHex": "#38bdf8",
    "description": "Noms d'attributs et de propriétés d'objet."
  },
  {
    "path": [
      "color",
      "syntax",
      "comment"
    ],
    "name": "color-syntax-comment",
    "cssVar": "--nx-color-syntax-comment",
    "type": "color",
    "value": "#94a3b8",
    "darkValue": "#64748b",
    "hex": "#94a3b8",
    "darkHex": "#64748b",
    "description": "Commentaires. Volontairement le plus faible contraste du jeu : un commentaire doit se laisser sauter à la lecture."
  },
  {
    "path": [
      "color",
      "syntax",
      "punctuation"
    ],
    "name": "color-syntax-punctuation",
    "cssVar": "--nx-color-syntax-punctuation",
    "type": "color",
    "value": "#64748b",
    "darkValue": "#94a3b8",
    "hex": "#64748b",
    "darkHex": "#94a3b8",
    "description": "Ponctuation et opérateurs. Atténués : ils structurent le code sans en porter le sens."
  },
  {
    "path": [
      "motion",
      "duration",
      "instant"
    ],
    "name": "motion-duration-instant",
    "cssVar": "--nx-motion-duration-instant",
    "type": "duration",
    "value": "70ms",
    "description": "Retour tactile immédiat : enfoncement d'un bouton, changement de couleur au survol."
  },
  {
    "path": [
      "motion",
      "duration",
      "fast"
    ],
    "name": "motion-duration-fast",
    "cssVar": "--nx-motion-duration-fast",
    "type": "duration",
    "value": "120ms",
    "description": "Défaut des micro-interactions : coche, focus, bascule d'état."
  },
  {
    "path": [
      "motion",
      "duration",
      "normal"
    ],
    "name": "motion-duration-normal",
    "cssVar": "--nx-motion-duration-normal",
    "type": "duration",
    "value": "200ms",
    "description": "Défaut du système. Apparition d'un élément, ouverture d'un panneau."
  },
  {
    "path": [
      "motion",
      "duration",
      "slow"
    ],
    "name": "motion-duration-slow",
    "cssVar": "--nx-motion-duration-slow",
    "type": "duration",
    "value": "320ms",
    "description": "Déplacements de grande amplitude : modale, indicateur d'onglet, accordéon."
  },
  {
    "path": [
      "motion",
      "duration",
      "slower"
    ],
    "name": "motion-duration-slower",
    "cssVar": "--nx-motion-duration-slower",
    "type": "duration",
    "value": "480ms",
    "description": "Progression, transitions de mise en page. Rarement justifié."
  },
  {
    "path": [
      "motion",
      "ease",
      "standard"
    ],
    "name": "motion-ease-standard",
    "cssVar": "--nx-motion-ease-standard",
    "type": "cubicBezier",
    "value": "cubic-bezier(0.2, 0, 0, 1)",
    "description": "Courbe par défaut. Démarre franchement, s'arrête en douceur — c'est ce qui donne l'impression de « poids » plutôt que de translation mécanique."
  },
  {
    "path": [
      "motion",
      "ease",
      "entrance"
    ],
    "name": "motion-ease-entrance",
    "cssVar": "--nx-motion-ease-entrance",
    "type": "cubicBezier",
    "value": "cubic-bezier(0.05, 0.7, 0.1, 1)",
    "description": "Pour ce qui apparaît. Décélération marquée : l'œil rattrape l'élément et se pose dessus."
  },
  {
    "path": [
      "motion",
      "ease",
      "exit"
    ],
    "name": "motion-ease-exit",
    "cssVar": "--nx-motion-ease-exit",
    "type": "cubicBezier",
    "value": "cubic-bezier(0.3, 0, 0.8, 0.15)",
    "description": "Pour ce qui disparaît. Accélération : inutile de faire suivre à l'œil un élément qui s'en va, autant libérer l'écran vite."
  },
  {
    "path": [
      "motion",
      "ease",
      "spring"
    ],
    "name": "motion-ease-spring",
    "cssVar": "--nx-motion-ease-spring",
    "type": "cubicBezier",
    "value": "cubic-bezier(0.34, 1.4, 0.64, 1)",
    "description": "Léger dépassement (1,4 au lieu de 1). Réservé aux bascules d'état binaires — interrupteur, coche — où le rebond confirme physiquement l'action. Jamais sur un déplacement de mise en page : le dépassement y ressemble à un bug de calcul."
  },
  {
    "path": [
      "shadow",
      "xs"
    ],
    "name": "shadow-xs",
    "cssVar": "--nx-shadow-xs",
    "type": "shadow",
    "value": "0 1px 2px 0 oklch(0% 0 0 / 0.04)",
    "description": "Séparation minimale : boutons, champs."
  },
  {
    "path": [
      "shadow",
      "raised-inset"
    ],
    "name": "shadow-raised-inset",
    "cssVar": "--nx-shadow-raised-inset",
    "type": "shadow",
    "value": "inset 0 1px 0 0 oklch(100% 0 0 / 0.16)",
    "description": "Arête lumineuse d'un pixel sur le bord supérieur d'un aplat coloré. C'est le détail qui distingue un bouton « natif » d'un rectangle plat : il simule la lumière rasante que renvoie une surface légèrement bombée. Invisible consciemment, immédiatement perceptible si on l'enlève."
  },
  {
    "path": [
      "shadow",
      "control-inset"
    ],
    "name": "shadow-control-inset",
    "cssVar": "--nx-shadow-control-inset",
    "type": "shadow",
    "value": "inset 0 1px 1px 0 oklch(0% 0 0 / 0.04)",
    "description": "Équivalent pour un contrôle sur fond clair : ombre interne très douce en haut du champ, qui creuse légèrement la surface."
  },
  {
    "path": [
      "shadow",
      "sm"
    ],
    "name": "shadow-sm",
    "cssVar": "--nx-shadow-sm",
    "type": "shadow",
    "value": "0 1px 3px 0 oklch(0% 0 0 / 0.06), 0 1px 2px -1px oklch(0% 0 0 / 0.04)",
    "description": "Card au repos."
  },
  {
    "path": [
      "shadow",
      "md"
    ],
    "name": "shadow-md",
    "cssVar": "--nx-shadow-md",
    "type": "shadow",
    "value": "0 4px 10px -2px oklch(0% 0 0 / 0.07), 0 2px 4px -2px oklch(0% 0 0 / 0.04)",
    "description": "Card survolée, popover."
  },
  {
    "path": [
      "shadow",
      "lg"
    ],
    "name": "shadow-lg",
    "cssVar": "--nx-shadow-lg",
    "type": "shadow",
    "value": "0 12px 24px -8px oklch(0% 0 0 / 0.12), 0 4px 8px -4px oklch(0% 0 0 / 0.05)",
    "description": "Menu déroulant, tooltip."
  },
  {
    "path": [
      "shadow",
      "overlay"
    ],
    "name": "shadow-overlay",
    "cssVar": "--nx-shadow-overlay",
    "type": "shadow",
    "value": "0 24px 48px -12px oklch(0% 0 0 / 0.2)",
    "description": "Modale. Seul niveau réellement marqué du système."
  },
  {
    "path": [
      "shadow",
      "glass-inset"
    ],
    "name": "shadow-glass-inset",
    "cssVar": "--nx-shadow-glass-inset",
    "type": "shadow",
    "value": "inset 0 1px 0 0 oklch(100% 0 0 / 0.25)",
    "description": "Bordure spéculaire supérieure pour les surfaces translucides de type verre dépoli (glassmorphism)."
  },
  {
    "path": [
      "spacing",
      "0"
    ],
    "name": "spacing-0",
    "cssVar": "--nx-spacing-0",
    "type": "dimension",
    "value": "0rem"
  },
  {
    "path": [
      "spacing",
      "1"
    ],
    "name": "spacing-1",
    "cssVar": "--nx-spacing-1",
    "type": "dimension",
    "value": "0.25rem"
  },
  {
    "path": [
      "spacing",
      "2"
    ],
    "name": "spacing-2",
    "cssVar": "--nx-spacing-2",
    "type": "dimension",
    "value": "0.5rem"
  },
  {
    "path": [
      "spacing",
      "3"
    ],
    "name": "spacing-3",
    "cssVar": "--nx-spacing-3",
    "type": "dimension",
    "value": "0.75rem"
  },
  {
    "path": [
      "spacing",
      "4"
    ],
    "name": "spacing-4",
    "cssVar": "--nx-spacing-4",
    "type": "dimension",
    "value": "1rem"
  },
  {
    "path": [
      "spacing",
      "5"
    ],
    "name": "spacing-5",
    "cssVar": "--nx-spacing-5",
    "type": "dimension",
    "value": "1.25rem"
  },
  {
    "path": [
      "spacing",
      "6"
    ],
    "name": "spacing-6",
    "cssVar": "--nx-spacing-6",
    "type": "dimension",
    "value": "1.5rem"
  },
  {
    "path": [
      "spacing",
      "8"
    ],
    "name": "spacing-8",
    "cssVar": "--nx-spacing-8",
    "type": "dimension",
    "value": "2rem"
  },
  {
    "path": [
      "spacing",
      "10"
    ],
    "name": "spacing-10",
    "cssVar": "--nx-spacing-10",
    "type": "dimension",
    "value": "2.5rem"
  },
  {
    "path": [
      "spacing",
      "12"
    ],
    "name": "spacing-12",
    "cssVar": "--nx-spacing-12",
    "type": "dimension",
    "value": "3rem"
  },
  {
    "path": [
      "spacing",
      "16"
    ],
    "name": "spacing-16",
    "cssVar": "--nx-spacing-16",
    "type": "dimension",
    "value": "4rem"
  },
  {
    "path": [
      "spacing",
      "20"
    ],
    "name": "spacing-20",
    "cssVar": "--nx-spacing-20",
    "type": "dimension",
    "value": "5rem"
  },
  {
    "path": [
      "spacing",
      "24"
    ],
    "name": "spacing-24",
    "cssVar": "--nx-spacing-24",
    "type": "dimension",
    "value": "6rem"
  },
  {
    "path": [
      "spacing",
      "32"
    ],
    "name": "spacing-32",
    "cssVar": "--nx-spacing-32",
    "type": "dimension",
    "value": "8rem"
  },
  {
    "path": [
      "spacing",
      "base"
    ],
    "name": "spacing-base",
    "cssVar": "--nx-spacing-base",
    "type": "dimension",
    "value": "0.25rem",
    "description": "Pas unitaire de la grille. Tout le reste en est un multiple."
  },
  {
    "path": [
      "radius",
      "none"
    ],
    "name": "radius-none",
    "cssVar": "--nx-radius-none",
    "type": "dimension",
    "value": "0rem"
  },
  {
    "path": [
      "radius",
      "sm"
    ],
    "name": "radius-sm",
    "cssVar": "--nx-radius-sm",
    "type": "dimension",
    "value": "0.375rem"
  },
  {
    "path": [
      "radius",
      "md"
    ],
    "name": "radius-md",
    "cssVar": "--nx-radius-md",
    "type": "dimension",
    "value": "0.5rem",
    "description": "Défaut des éléments interactifs natifs : boutons, champs, chips (8px)."
  },
  {
    "path": [
      "radius",
      "lg"
    ],
    "name": "radius-lg",
    "cssVar": "--nx-radius-lg",
    "type": "dimension",
    "value": "0.75rem",
    "description": "Grands boutons et contrôles surélevés (12px)."
  },
  {
    "path": [
      "radius",
      "xl"
    ],
    "name": "radius-xl",
    "cssVar": "--nx-radius-xl",
    "type": "dimension",
    "value": "1rem",
    "description": "Défaut des conteneurs : cards, modales, panneaux (16px)."
  },
  {
    "path": [
      "radius",
      "2xl"
    ],
    "name": "radius-2xl",
    "cssVar": "--nx-radius-2xl",
    "type": "dimension",
    "value": "1.25rem"
  },
  {
    "path": [
      "radius",
      "full"
    ],
    "name": "radius-full",
    "cssVar": "--nx-radius-full",
    "type": "dimension",
    "value": "9999px"
  },
  {
    "path": [
      "font",
      "family",
      "sans"
    ],
    "name": "font-family-sans",
    "cssVar": "--nx-font-family-sans",
    "type": "fontFamily",
    "value": "Inter, ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif"
  },
  {
    "path": [
      "font",
      "family",
      "display"
    ],
    "name": "font-family-display",
    "cssVar": "--nx-font-family-display",
    "type": "fontFamily",
    "value": "'Inter Display', Inter, ui-sans-serif, system-ui, sans-serif",
    "description": "Titres et grandes accroches."
  },
  {
    "path": [
      "font",
      "family",
      "mono"
    ],
    "name": "font-family-mono",
    "cssVar": "--nx-font-family-mono",
    "type": "fontFamily",
    "value": "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace"
  },
  {
    "path": [
      "font",
      "size",
      "xs"
    ],
    "name": "font-size-xs",
    "cssVar": "--nx-font-size-xs",
    "type": "dimension",
    "value": "0.75rem",
    "lineHeight": "1rem"
  },
  {
    "path": [
      "font",
      "size",
      "sm"
    ],
    "name": "font-size-sm",
    "cssVar": "--nx-font-size-sm",
    "type": "dimension",
    "value": "0.875rem",
    "lineHeight": "1.25rem"
  },
  {
    "path": [
      "font",
      "size",
      "base"
    ],
    "name": "font-size-base",
    "cssVar": "--nx-font-size-base",
    "type": "dimension",
    "value": "1rem",
    "lineHeight": "1.5rem"
  },
  {
    "path": [
      "font",
      "size",
      "lg"
    ],
    "name": "font-size-lg",
    "cssVar": "--nx-font-size-lg",
    "type": "dimension",
    "value": "1.125rem",
    "lineHeight": "1.75rem"
  },
  {
    "path": [
      "font",
      "size",
      "xl"
    ],
    "name": "font-size-xl",
    "cssVar": "--nx-font-size-xl",
    "type": "dimension",
    "value": "1.25rem",
    "lineHeight": "1.75rem"
  },
  {
    "path": [
      "font",
      "size",
      "2xl"
    ],
    "name": "font-size-2xl",
    "cssVar": "--nx-font-size-2xl",
    "type": "dimension",
    "value": "1.5rem",
    "lineHeight": "2rem"
  },
  {
    "path": [
      "font",
      "size",
      "3xl"
    ],
    "name": "font-size-3xl",
    "cssVar": "--nx-font-size-3xl",
    "type": "dimension",
    "value": "1.875rem",
    "lineHeight": "2.25rem"
  },
  {
    "path": [
      "font",
      "size",
      "4xl"
    ],
    "name": "font-size-4xl",
    "cssVar": "--nx-font-size-4xl",
    "type": "dimension",
    "value": "2.25rem",
    "lineHeight": "2.5rem"
  },
  {
    "path": [
      "font",
      "size",
      "5xl"
    ],
    "name": "font-size-5xl",
    "cssVar": "--nx-font-size-5xl",
    "type": "dimension",
    "value": "3rem",
    "lineHeight": "1.1"
  },
  {
    "path": [
      "font",
      "size",
      "6xl"
    ],
    "name": "font-size-6xl",
    "cssVar": "--nx-font-size-6xl",
    "type": "dimension",
    "value": "3.75rem",
    "lineHeight": "1.05"
  },
  {
    "path": [
      "font",
      "weight",
      "normal"
    ],
    "name": "font-weight-normal",
    "cssVar": "--nx-font-weight-normal",
    "type": "fontWeight",
    "value": "400"
  },
  {
    "path": [
      "font",
      "weight",
      "medium"
    ],
    "name": "font-weight-medium",
    "cssVar": "--nx-font-weight-medium",
    "type": "fontWeight",
    "value": "500"
  },
  {
    "path": [
      "font",
      "weight",
      "semibold"
    ],
    "name": "font-weight-semibold",
    "cssVar": "--nx-font-weight-semibold",
    "type": "fontWeight",
    "value": "600"
  },
  {
    "path": [
      "font",
      "weight",
      "bold"
    ],
    "name": "font-weight-bold",
    "cssVar": "--nx-font-weight-bold",
    "type": "fontWeight",
    "value": "700"
  },
  {
    "path": [
      "font",
      "tracking",
      "tight"
    ],
    "name": "font-tracking-tight",
    "cssVar": "--nx-font-tracking-tight",
    "type": "dimension",
    "value": "-0.025em"
  },
  {
    "path": [
      "font",
      "tracking",
      "normal"
    ],
    "name": "font-tracking-normal",
    "cssVar": "--nx-font-tracking-normal",
    "type": "dimension",
    "value": "0em"
  },
  {
    "path": [
      "font",
      "tracking",
      "wide"
    ],
    "name": "font-tracking-wide",
    "cssVar": "--nx-font-tracking-wide",
    "type": "dimension",
    "value": "0.025em"
  }
];

export default tokens;
